import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Components, Feedback, Utils, translate,
} from 'versafleet-core';
import ReduxActions from 'reduxActions';
import MobileGlobalSearch from 'modules/mobileGlobalSearch';
import classNames from 'classnames';
import Header from './header';
import PageNotFound from './pageNotFound';
import LoginLoading from './authentication/loginLoading';

const {
  UserAgentDetector, Helper, Router, FullScreenLoading,
} = Utils;

class MainContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: window.performance.navigation.type === 0,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(ReduxActions.profile.check())
      .then(() => {
        this.props.dispatch(ReduxActions.account.fetch());
        this.props.dispatch(ReduxActions.notification.loadNewCount());
      })
      .catch(() => {
        Router.transitionTo('/auth/login');
      });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!Helper.isNullOrUndefined(nextProps.profile)) {
      if (this.state.isLoading) {
        setTimeout(() => {
          this.setState({ isLoading: false });
        }, 1000);
      }
    }
  }

  _logout = () => {
    this.props.dispatch(ReduxActions.profile.logout(''));
  }

  _loadGlobalSearchItem = (data) => {
    const { id } = data;
    if (data.guid.indexOf('JB') === -1) {
      if (Router.getPath().indexOf('archives') === -1) {
        Router.transitionTo(`/tasks/${id}`);
      } else {
        Router.transitionTo(`/archives/tasks/${id}`);
      }
    } else if (Router.getPath().indexOf('archives') === -1) {
      Router.transitionTo(`/jobs/${id}`);
    } else {
      Router.transitionTo(`/archives/jobs/${id}`);
    }
  }

  _renderLoading() {
    let welcomeMessage = 'Logging you in';
    if (!Helper.isNullOrUndefined(this.props.profile)) {
      welcomeMessage = `Welcome, ${this.props.profile.name}`;
    }
    return (
      <LoginLoading text={welcomeMessage} />
    );
  }

  _renderMenu() {
    const routes = [{
      iconClassName: 'versa-home',
      children: this.props.strings.MobileMenu.home,
      route: '/tasks',
      id: 'vf-mobile-menu__home',
    }, {
      iconClassName: 'versa-notifications',
      iconText: '',
      children: (
        <span className="versafleet__main-container__mobile-notification-item">
          {this.props.strings.MobileMenu.notifications}
          {
            this.props.newCount > 0
              ? (
                <span className="versafleet__main-container__mobile-notification-item__count">
                  {this.props.newCount}
                </span>
              ) : false
          }
        </span>
      ),
      route: '/notifications',
      id: 'vf-mobile-menu__notifications',
    }, {
      iconClassName: 'versa-archive',
      iconText: '',
      children: this.props.strings.MobileMenu.archives,
      route: '/archives/tasks',
      id: 'vf-mobile-menu__archives',
    }, {
      iconClassName: 'versa-logout',
      iconText: '',
      children: this.props.strings.MobileMenu.logout,
      onClick: this._logout.bind(this),
      id: 'vf-mobile-menu__logout',
    }];

    if (!Helper.isNullOrUndefined(this.props.profile)) {
      const hasContactPerson = Helper.isNonEmptyString(this.props.profile.contact_person);
      const hasContactNumber = Helper.isNonEmptyString(this.props.profile.contact_number);
      const hasEmail = Helper.isNonEmptyString(this.props.profile.email);

      const contactPersonClassName = classNames({
        'versafleet__main-container__mobile-header-item': true,
        'versafleet__main-container__mobile-header-item--placeholder': !hasContactPerson,
      });
      const contactNumberClassName = classNames({
        'versafleet__main-container__mobile-header-item': true,
        'versafleet__main-container__mobile-header-item--placeholder': !hasContactNumber,
      });
      const emailClassName = classNames({
        'versafleet__main-container__mobile-header-item': true,
        'versafleet__main-container__mobile-header-item--placeholder': !hasEmail,
      });

      return (
        <Components.Mobile.Menu
          activator={this.props.profile.account_name}
          headerItems={[(
            <Components.Mobile.MenuHeaderItem
              className={contactPersonClassName}
              iconClassName="versa-person"
              key="header-item-contact-person"
            >
              {hasContactPerson ? this.props.profile.contact_person
                : this.props.strings.MobileMenu.headers.contactPersonPlaceholder}
            </Components.Mobile.MenuHeaderItem>
          ), (
            <Components.Mobile.MenuHeaderItem
              className={contactNumberClassName}
              iconClassName="versa-call"
              key="header-item-contact-number"
            >
              {hasContactNumber ? this.props.profile.contact_number
                : this.props.strings.MobileMenu.headers.contactNumberPlaceholder}
            </Components.Mobile.MenuHeaderItem>
          ), (
            <Components.Mobile.MenuHeaderItem
              className={emailClassName}
              iconClassName="versa-email"
              key="header-item-email"
            >
              {hasEmail ? this.props.profile.email
                : this.props.strings.MobileMenu.headers.emailPlaceholder}
            </Components.Mobile.MenuHeaderItem>
          )]}
          headerTitle={this.props.profile.name}
          logoSrc="/assets/images/versafleet.png"
          routes={routes}
        />
      );
    }

    return false;
  }

  _renderSearch() {
    return (
      <Components.Mobile.Search
        search={(
          <MobileGlobalSearch
            className="vf-header__header-actions__mobile-global-search"
            onClickItem={this._loadGlobalSearchItem}
          />
        )}
      />
    );
  }

  _renderMainContainer() {
    return this.props.isChecked
      ? (
        <div className="versafleet__main-container">
          {UserAgentDetector.isMobileOrTablet() ? this._renderMenu() : false}
          {UserAgentDetector.isMobileOrTablet() ? this._renderSearch() : false}
          <div className="vf-main-content">
            {UserAgentDetector.isMobileOrTablet() ? false : (
              <Header
                account={this.props.account}
                logout={this._logout}
                profile={this.props.profile}
                title={this.props.strings.Titles[this.props.titleKey]}
              />
            )}
            {this.props.children}
          </div>
          <div className="versafleet__main-container__progress">
            <Feedback.Progress.Component />
          </div>
          <FullScreenLoading.FullScreenLoadingComponent />
        </div>
      ) : false;
  }

  _renderPageNotFound = () => (
    <PageNotFound />
  );

  render() {
    if (this.state.isLoading) {
      return this._renderLoading();
    }

    let isPageAllowed = true;
    // This guard is necessary so that the Not Found Page is not flashed before every refresh
    if (!Helper.isNullOrUndefined(this.props.profile)) {
      if (this.props.editOnly && this.props.profile.myjobs_setting.read_only) {
        isPageAllowed = false;
      }
    }

    return isPageAllowed ? this._renderMainContainer() : this._renderPageNotFound();
  }
}

MainContainer.displayName = 'Main Container';

MainContainer.propTypes = {
  account: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
  dispatch: PropTypes.func.isRequired,
  editOnly: PropTypes.bool,
  isChecked: PropTypes.bool.isRequired,
  newCount: PropTypes.number,
  profile: PropTypes.shape({
    account_name: PropTypes.string,
    contact_person: PropTypes.string,
    contact_number: PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string,
    myjobs_setting: PropTypes.shape({
      read_only: PropTypes.bool,
    }),
  }),
  strings: PropTypes.shape({
    MobileMenu: PropTypes.shape({
      home: PropTypes.string,
      notifications: PropTypes.string,
      archives: PropTypes.string,
      logout: PropTypes.string,
      headers: PropTypes.shape({
        contactPersonPlaceholder: PropTypes.string,
        contactNumberPlaceholder: PropTypes.string,
        emailPlaceholder: PropTypes.string,
      }),
    }),
    Titles: PropTypes.shape(),
  }).isRequired,
  titleKey: PropTypes.string,
};

MainContainer.defaultProps = {
  account: null,
  editOnly: false,
  newCount: 0,
  profile: {},
  titleKey: '',
};

function mapStateToProps(state) {
  const { account, profile, notification } = state;
  return {
    account: account.account,
    profile: profile.profile,
    isChecked: profile.isChecked,
    newCount: notification.newCount,
  };
}

export default connect(mapStateToProps)(translate('')(MainContainer));
